/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

document.querySelectorAll('.js-product').forEach(product => {
    let lastDimension = null;

    const updateLotStock = (dimension) => {
        if (!dimension) return;
        lastDimension = dimension;
        product.querySelectorAll('[data-lot-stock]').forEach(span => {
            span.style.display = span.dataset.dimension === dimension ? '' : 'none';
        });
    };

    const checkedDimension = product.querySelector('[data-option="Dimensions"] input:checked')?.value;
    updateLotStock(checkedDimension);

    product.addEventListener('on:variant:change', (evt) => {
        const { variant } = evt.detail;
        const dimension = variant ? variant.option1 : lastDimension;
        updateLotStock(dimension);
    });
});

// Block autoscroll when variant is clicked
window.addEventListener('scroll', () => {
    if (window.scrollX !== 0) {
        window.scrollTo({ left: 0, top: window.scrollY, behavior: 'instant' });
    }
}, { passive: true });